// quantiix-shell/src/config/routes.js

/**
 * Route configuration - Single source of truth for all MFE routes
 */
export const ROUTES = {
    // Dashboard MFE
    companies: () => '/app/dashboard',
    factories: (companyId) => `/app/dashboard/company/${companyId}`,
    ous: (factoryId) => `/app/dashboard/factory/${factoryId}`,

    // PublicView MFE
    publicview: (ouId) => `/app/publicview/${ouId}`,

    // Machine MFE
    machine: (machineId) => `/app/machine/${machineId}`,

    // Config MFE (NEW)
    config: {
        companies: () => '/app/config',
        factories: (companyId) => `/app/config/company/${companyId}`,
        ous: (factoryId) => `/app/config/factory/${factoryId}`,
        publicviews: (ouId) => `/app/config/ou/${ouId}`,
    }
};

/**
 * Parse current pathname to determine entity type and ID
 *
 * @returns {Object} { entityType, entityId, source }
 *   - source: 'dashboard' | 'config' | 'publicview' | 'machine'
 */
export function parseCurrentRoute(pathname) {
    const patterns = [
        // Machine MFE (unchanged)
        { regex: /^\/app\/machine\/([^/]+)$/, type: 'machine', source: 'machine' },

        // PublicView MFE (unchanged)
        { regex: /^\/app\/publicview\/([^/]+)$/, type: 'publicview', source: 'publicview' },

        // Dashboard MFE (unchanged - add source)
        { regex: /^\/app\/dashboard\/ou\/([^/]+)$/, type: 'ou', source: 'dashboard' },
        { regex: /^\/app\/dashboard\/factory\/([^/]+)$/, type: 'factory', source: 'dashboard' },
        { regex: /^\/app\/dashboard\/company\/([^/]+)$/, type: 'company', source: 'dashboard' },
        { regex: /^\/app\/dashboard\/?$/, type: 'companies', source: 'dashboard' },

        // Config MFE (NEW)
        { regex: /^\/app\/config\/ou\/([^/]+)$/, type: 'ou', source: 'config' },
        { regex: /^\/app\/config\/factory\/([^/]+)$/, type: 'factory', source: 'config' },
        { regex: /^\/app\/config\/company\/([^/]+)$/, type: 'company', source: 'config' },
        { regex: /^\/app\/config\/?$/, type: 'companies', source: 'config' },
    ];

    for (const { regex, type, source } of patterns) {
        const match = pathname.match(regex);
        if (match) {
            return {
                entityType: type,
                entityId: match[1] || null,
                source
            };
        }
    }

    return { entityType: null, entityId: null, source: null };
}